import React from 'react'
import { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Link, useHistory } from 'react-router-dom'
import CustomPrimeTable, { DEFAULT_PAGE_SAZE } from '../../../../../../common/PrimeTable/CustomPrimeTable'
import { getActivitySummaryContacts, clearActivitySummaryContacts } from '../redux/actions'
import queryString from 'query-string'
import Loader from '../../../../../Loader/BasicLoader'
import moment from 'moment'
import { MEETING } from '../../../../../../constants/activityTypes'

const DEFAULT_PAGINATION = { limit: DEFAULT_PAGE_SAZE, first: 0 }

const DEFAULT_SORT_META = [{ field: 'creationName', order: 1 }]

// userId filter is used in preview mode only
export default function ActivitySummaryContactModal({
  type,
  dateRange,
  filterBy,
  userId,
  divisionId,
  divisionSummary,
}) {
  const [options, setOptions] = useState({
    pagination: DEFAULT_PAGINATION,
    sort: { creationDate: 1 },
    filter: { type, dateRange, filterBy, userId, divisionId, divisionSummary },
    tableFilter: {},
  })

  const { data, query, isLoading } = useSelector((state) => ({
    data: state.dashboardActivitySummary.contactsData.data,
    query: state.dashboardActivitySummary.contactsData.query,
    isLoading: state.dashboardActivitySummary.isLoading,
  }))

  const history = useHistory()
  const dispatch = useDispatch()

  useEffect(() => {
    return () => {
      dispatch(clearActivitySummaryContacts())
    }
  }, [])

  useEffect(() => {
    dispatch(getActivitySummaryContacts(options))
  }, [options])

  const handleSortChange = async (event) => {
    let sort = {}

    if (event.multiSortMeta) {
      event.multiSortMeta.map((row) => {
        sort[row.field] = row.order
      })
    }

    setOptions({
      ...options,
      sort,
      pagination: DEFAULT_PAGINATION,
    })
  }

  const handlePageChange = async (event) => {
    await history.push({
      pathname: history.location.pathname,
      search: `?first=${event.first}&limit=${event.rows}`,
    })

    const pagination = queryString.parse(history.location.search)
    setOptions({
      ...options,
      pagination,
    })
  }

  const sortMeta = () => {
    if (options?.sort) {
      const field = Object.keys(options?.sort)[0]
      const order = options?.sort[field]

      return [
        {
          field,
          order,
        },
      ]
    } else {
      return DEFAULT_SORT_META
    }
  }

  const dateBody = ({ activityTypeData, creationDate }) => {
    const date =
      activityTypeData?.id === MEETING && activityTypeData.meetingStart ? activityTypeData.meetingStart : creationDate

    return <div>{moment.utc(date).local().format('MM-DD-YYYY')}</div>
  }

  const userBody = (rowData) => {
    return <div>{rowData.userData.name}</div>
  }

  const contactNameBody = (rowData) => {
    return (
      <Link onClick={() => window.open(`/contacts/${rowData.contactData.id}`, '_blank')} rel='noopener noreferrer'>
        {rowData.contactData.name}
      </Link>
    )
  }

  const companyOwnerBody = (rowData) => {
    return <div>{rowData.contactData.companyOwner}</div>
  }

  const trucksBody = (rowData) => {
    return <div>{rowData.contactData.numberOfTrucks}</div>
  }

  const stateBody = (rowData) => {
    return <div>{rowData.stateData.name}</div>
  }

  const activityTypeBody = (rowData) => {
    return <div>{rowData?.activityTypeData?.name}</div>
  }

  const notesBody = (rowData) => {
    return (
      <div
        dangerouslySetInnerHTML={{
          __html: rowData.notes,
        }}
      />
    )
  }

  const columns = [
    { field: 'creationDate', header: 'Date', body: dateBody },
    { field: 'userName', header: 'User', body: userBody },
    { field: 'contactName', header: 'Contact', body: contactNameBody },
    { field: 'contactOwnerName', header: 'Company Owner', body: companyOwnerBody },
    { field: 'contactNumberOfTrucks', header: 'Trucks', body: trucksBody },
    { field: 'stateName', header: 'State', body: stateBody },
    { field: 'activityTypeName', header: 'Activity Type', body: activityTypeBody },
    { field: 'notes', header: 'Notes', body: notesBody, style: { width: '30%' } },
  ]

  return (
    <>
      {isLoading && <Loader />}
      <CustomPrimeTable
        data={data}
        columns={columns}
        findHidden
        addHidden
        onFilter={() => {}}
        onSort={handleSortChange}
        onPage={handlePageChange}
        defaultSortMeta={sortMeta()}
        query={query}
        showActions={false}
      />
    </>
  )
}
